/**
 * The words an order list shows for an order (orders.status) and its money
 * (orders.payment_status) - ONE vocabulary for the register's Orders and the back
 * office's Orders. An unknown value is shown as itself, never as "Pending".
 *
 * tone: a page maps it to its own colours (dark register / light back office).
 */
export const ORDER_STATUS = {
  awaiting_payment: { label: 'Awaiting payment', tone: 'amber' },
  pending: { label: 'Pending', tone: 'amber' },
  confirmed: { label: 'Confirmed', tone: 'blue' },
  in_progress: { label: 'In progress', tone: 'blue' },
  preparing: { label: 'Preparing', tone: 'orange' },
  ready: { label: 'Ready', tone: 'green' },
  out_for_delivery: { label: 'Out for delivery', tone: 'purple' },
  served: { label: 'Served', tone: 'slate' },
  completed: { label: 'Completed', tone: 'slate' },
  cancelled: { label: 'Cancelled', tone: 'red' },
};

export const PAYMENT_STATUS = {
  pending: { label: 'Unpaid', tone: 'amber' },
  partial: { label: 'Balance due', tone: 'amber' },
  paid: { label: 'Paid', tone: 'green' },
  partially_refunded: { label: 'Partly refunded', tone: 'orange' },
  refunded: { label: 'Refunded', tone: 'red' },
  voided: { label: 'Voided', tone: 'slate' },
  failed: { label: 'Payment failed', tone: 'red' },
};

const words = (value) => {
  const text = String(value || '').replace(/_/g, ' ').trim();
  return text ? text[0].toUpperCase() + text.slice(1) : 'Unknown';
};

export function orderStatus(value) {
  return ORDER_STATUS[value] || { label: words(value), tone: 'slate' };
}

export function paymentStatus(value) {
  return PAYMENT_STATUS[value] || { label: words(value), tone: 'slate' };
}

/** Badge classes per tone. */
export const DARK_TONES = {
  amber: 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30',
  blue: 'bg-blue-500/20 text-blue-300 border-blue-500/30',
  orange: 'bg-orange-500/20 text-orange-300 border-orange-500/30',
  green: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30',
  purple: 'bg-purple-500/20 text-purple-300 border-purple-500/30',
  slate: 'bg-slate-500/20 text-slate-300 border-slate-500/30',
  red: 'bg-red-500/20 text-red-300 border-red-500/30',
};

export const LIGHT_TONES = {
  amber: 'bg-yellow-100 text-yellow-800',
  blue: 'bg-blue-100 text-blue-800',
  orange: 'bg-orange-100 text-orange-800',
  green: 'bg-green-100 text-green-800',
  purple: 'bg-purple-100 text-purple-800',
  slate: 'bg-slate-100 text-slate-800',
  red: 'bg-red-100 text-red-800',
};
